import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@wehunt/core-web'
import { useApiFetch } from '../../shared/api'

export interface GroupMemberDto {
  id: string
  name: string
  role: string
  avatar: string
  imageUrl?: string
  deleted?: boolean
}

export interface GroupMembersResponse {
  members: GroupMemberDto[]
}

export function useGroupMembers(groupId: string) {
  const call = useApiFetch()
  const { state } = useAuth()
  const uid = state.status === 'signed-in' ? state.user.uid : undefined
  return useQuery({
    queryKey: ['clubhouse', 'groups', groupId, 'members'],
    queryFn: () => call<GroupMembersResponse>(`/clubhouse/groups/${groupId}/members`),
    enabled: !!uid && !!groupId,
    staleTime: 5 * 60 * 1000,
  })
}
